// Dialog generico de movimento de caixa (Sangria ou Suprimento).
// Componente unico que se adapta via props (label, icone, cor, placeholder).

import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { InputDecimal } from "../../../components/ui/input-decimal";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../components/ui/dialog";

export default function MovimentoDialog({
  open,
  onOpenChange,
  title,
  icon,
  buttonLabel,
  buttonClass = "bg-red-500 hover:bg-red-600 text-white",
  placeholderObs = "Motivo...",
  valor,
  setValor,
  observacao,
  setObservacao,
  onConfirm,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {icon} {title}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <label className="text-sm font-medium">Valor (R$)</label>
            {/* Campo "de caixa registradora": antes, digitar "1.234,56" virava
                R$ 1,23 (achado 230). */}
            <InputDecimal
              decimals={2}
              value={valor ? String(valor) : ""}
              onChange={(v) => setValor(v ? parseFloat(v) : 0)}
              className="h-11 text-lg font-bold"
              autoFocus
            />
          </div>
          <div>
            <label className="text-sm font-medium">Observação</label>
            <Input
              value={observacao}
              onChange={(e) => setObservacao(e.target.value)}
              placeholder={placeholderObs}
            />
          </div>
          <Button onClick={onConfirm} className={`w-full ${buttonClass}`}>
            {buttonLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
